if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true
}
import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'

const recaptchaKey = import.meta.env.VITE_RECAPTCHA_KEY

const app = initializeApp({
  apiKey: 'AIzaSyAMs2kyYhDdADGnBN6OmEkabszvxO7YxGY',
  authDomain: 'gymnastic-britannia.firebaseapp.com',
  projectId: 'gymnastic-britannia',
  storageBucket: 'gymnastic-britannia.firebasestorage.app',
  messagingSenderId: '103192908098',
  appId: '1:103192908098:web:0ab75b6ef5da56955578db',
  measurementId: 'G-ZHEFN6X5GC',
})

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(recaptchaKey),
  isTokenAutoRefreshEnabled: true,
})

export const auth = getAuth(app)
export const db = getFirestore(app)
export const functions = getFunctions(app, 'us-central1')

// if (window.location.hostname === 'localhost') {
//   connectAuthEmulator(auth, 'http://localhost:9099')
//   connectFirestoreEmulator(db, 'localhost', 8080)
//   connectFunctionsEmulator(functions, 'localhost', 5001)
// }

export default app
